<template>
  <div class="card card-profile bg-dark text-white mb-3">
    <div class="card-header header-avatar" style="background-image: url('/static/img/gamification/banner-bg.jpg')">
      <div class="profile-picture">
        <div class="avatar avatar-xl">
          <img onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="currentArtist.cover_image_small || currentArtist.cover_image" alt="..." class="avatar-img rounded-circle">
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="user-profile text-center">
        <div class="pos-relative">
          <div class="name">
            <span>
              {{ (currentArtist.name || '') | truncate(27) }}
            </span>
            <div class="dropdown dropdown-artists d-inline ml-1">
              <button class="btn btn-default btn-xs dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a v-for="(artist, index) in artists" class="dropdown-item" href="javascript:void(0)" v-bind:key="`artistSelect_${index}`" @click="changeArtist(artist)">
                  {{ artist.name  }}
                </a>
              </div>
            </div>
          </div>
          <div class="job">{{ currentArtist.ranking && currentArtist.ranking.length ? currentArtist.ranking[0].rank : 'Unranked' }}</div>
        </div>
        <div class="mt-3">
          <div class="progress rank-progress">
            <div class="progress-bar bg-success" role="progressbar" :style="`width: ${(artistScore / artistNextScore * 100) || 1}%`" :aria-valuenow="(artistScore / artistNextScore * 100)" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
        <div class="mt-3">
          <router-link to="/challenges" class="btn btn-block btn-default">
            {{ $t('view_challenges') }}
          </router-link>
        </div>
      </div>
    </div>
    <!-- <div class="card-footer mt-2">
      <div class="row user-stats text-center">
        <div class="col">
          <div class="number">{{ numberWithCommas(artistScore) }} / {{ numberWithCommas(artistNextScore) }}</div>
          <div class="title">{{ $t('next_rank') }}</div>
        </div>
        <div class="col">
          <div class="number">{{ achievments }}</div>
          <div class="title">{{ $t('achievments') }}</div>
        </div>
        <div class="col">
          <div class="number">{{ medals }}</div>
          <div class="title">{{ $t('medals') }}</div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import Artists from '../services/artists'
import Filters from '../components/utils/filters'
import _ from 'underscore'

export default {
  name: 'ArtistScoreCard',
  data () {
    return {
      artists: [],
      currentArtist: {
        cover_image_small: '/static/img/img-placeholder-dark.jpg'
      },
      artistScore: 0,
      artistNextScore: 0,
      ranksScore: {
        'Unranked': {nextRank: 'Bronze', nextScore: 100},
        'Bronze': {nextRank: 'Silver', nextScore: 1000},
        'Silver': {nextRank: 'Gold', nextScore: 2500},
        'Gold': {nextRank: 'Platinum', nextScore: 4000},
        'Platinum': {nextRank: 'Diamond', nextScore: 6000},
        'Diamond': {nextRank: 'Star', nextScore: 10000},
        'Star': {nextRank: 'Superstar', nextScore: 25000},
        'Superstar': {nextRank: 'Legend', nextScore: 50000},
        'Legend': {nextRank: 'Rockstar', nextScore: 100000}
      }
    }
  },
  methods: {
    changeArtist: function (artist) {
      localStorage.setItem('defaultCachedArtist', artist._id)
      this.currentArtist = artist
      this.artistsShortList = []

      this.artistScore = this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].score : 0
      this.artistNextScore = this.ranksScore[this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].rank : 'Unranked'].nextScore
      this.$forceUpdate()
    }
  },
  created: function () {
    this.user = this.$user
    this.defaultCachedArtist = localStorage.getItem('defaultCachedArtist')

    Artists.getAll().then(response => {
      this.artists = _.map(response.data, item => {
        return {
          id: item._id,
          _id: item._id,
          text: item.name,
          name: item.name,
          spotify_id: item.spotify_id,
          cover_image: item.cover_image,
          cover_image_small: item.cover_image_small,
          ranking: item.ranking
        }
      })

      if (this.defaultCachedArtist && _.find(this.artists, item => item._id === this.defaultCachedArtist)) {
        this.currentArtist = _.find(this.artists, item => item._id === this.defaultCachedArtist)
      } else {
        this.currentArtist = this.artists[0]
      }

      setTimeout(() => {
        this.artistScore = this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].score : 0
        this.artistNextScore = this.ranksScore[this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].rank : 'Unranked'].nextScore
        this.$forceUpdate()
      }, 500)
    })
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
.header-avatar {
  border-radius: 6px 6px 0 0 !important;
  background-color: #2e294e;
  background-image: url('/static/img/gamification/banner-bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  border-bottom: #2e294e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ArtistScoreCard.vue